// extracted by mini-css-extract-plugin
module.exports = {"container":"_6FvB-6Cvo_hKZe62vY3v7"};